/// <reference types="unplugin-icons/types/react" />
/**
 * The app's icon set: Solar (480 Design, CC BY 4.0), compiled into the bundle by
 * unplugin-icons at build time. Exports keep the Lucide names the code already uses,
 * so a call site only changes its import line; restyling an icon is one edit here.
 * Approved mapping: docs/plans/previews/mapping-final.json (Solar has no toggle or
 * brand marks, so those few come from MingCute and Simple Icons).
 */
import { ComponentType, createElement, forwardRef, ForwardRefExoticComponent, Ref, RefAttributes, SVGProps } from 'react'

import IMingcuteToggleLeftLine from '~icons/mingcute/toggle-left-line'
import IMingcuteToggleRightLine from '~icons/mingcute/toggle-right-line'
import ISimpleIconsSlack from '~icons/simple-icons/slack'
import ISolarAddFolderLinear from '~icons/solar/add-folder-linear'
import IFairgenGaugeHigh from '~icons/fairgen/gauge-high'
import IFairgenGaugeLow from '~icons/fairgen/gauge-low'
import IFairgenGaugeMedium from '~icons/fairgen/gauge-medium'
import ISolarAddLinear from '~icons/solar/add-linear'
import ISolarDialog2Linear from '~icons/solar/dialog-2-linear'
import ISolarChatRoundLineLinear from '~icons/solar/chat-round-line-linear'
import ISolarAlignBottomLinear from '~icons/solar/align-bottom-linear'
import ISolarAlignLeftLinear from '~icons/solar/align-left-linear'
import ISolarAlignTopLinear from '~icons/solar/align-top-linear'
import ISolarAltArrowDownLinear from '~icons/solar/alt-arrow-down-linear'
import ISolarAltArrowLeftLinear from '~icons/solar/alt-arrow-left-linear'
import ISolarAltArrowRightLinear from '~icons/solar/alt-arrow-right-linear'
import ISolarAltArrowUpLinear from '~icons/solar/alt-arrow-up-linear'
import ISolarArchiveLinear from '~icons/solar/archive-linear'
import ISolarArchiveUpLinear from '~icons/solar/archive-up-linear'
import ISolarArrowDownLinear from '~icons/solar/arrow-down-linear'
import ISolarArrowDownToLineLinear from '~icons/solar/arrow-down-to-line-linear'
import ISolarArrowLeftLinear from '~icons/solar/arrow-left-linear'
import ISolarArrowRightDownLinear from '~icons/solar/arrow-right-down-linear'
import ISolarArrowRightLinear from '~icons/solar/arrow-right-linear'
import ISolarArrowRightUpLinear from '~icons/solar/arrow-right-up-linear'
import ISolarArrowUpLinear from '~icons/solar/arrow-up-linear'
import ISolarBagLinear from '~icons/solar/bag-linear'
import ISolarBellBingLinear from '~icons/solar/bell-bing-linear'
import ISolarBellLinear from '~icons/solar/bell-linear'
import ISolarBoltLinear from '~icons/solar/bolt-linear'
import ISolarBookmarkLinear from '~icons/solar/bookmark-linear'
import ISolarBookmarkSquareLinear from '~icons/solar/bookmark-square-linear'
import ISolarBookmarkSquareMinimalisticLinear from '~icons/solar/bookmark-square-minimalistic-linear'
import ISolarBotLinear from '~icons/solar/bot-linear'
import ISolarBoxLinear from '~icons/solar/box-linear'
import ISolarBoxMinimalisticLinear from '~icons/solar/box-minimalistic-linear'
import ISolarBracesLinear from '~icons/solar/braces-linear'
import ISolarBranchingPathsDownLinear from '~icons/solar/branching-paths-down-linear'
import ISolarBugLinear from '~icons/solar/bug-linear'
import ISolarBuildings2Linear from '~icons/solar/buildings-2-linear'
import ISolarBuildingsLinear from '~icons/solar/buildings-linear'
import ISolarCalculatorLinear from '~icons/solar/calculator-linear'
import ISolarCalendarDateLinear from '~icons/solar/calendar-date-linear'
import ISolarCalendarLinear from '~icons/solar/calendar-linear'
import ISolarCalendarMinimalisticLinear from '~icons/solar/calendar-minimalistic-linear'
import ISolarCarLinear from '~icons/solar/car-linear'
import ISolarCardLinear from '~icons/solar/card-linear'
import ISolarCartLinear from '~icons/solar/cart-linear'
import ISolarCaseLinear from '~icons/solar/case-linear'
import ISolarChart2Linear from '~icons/solar/chart-2-linear'
import ISolarChartLinear from '~icons/solar/chart-linear'
import ISolarChatRoundLinear from '~icons/solar/chat-round-linear'
import ISolarChatSquareAddLinear from '~icons/solar/chat-square-add-linear'
import ISolarCheckCircleLinear from '~icons/solar/check-circle-linear'
import ISolarCheckLinear from '~icons/solar/check-linear'
import ISolarCheckSquareLinear from '~icons/solar/check-square-linear'
import ISolarChecklistLinear from '~icons/solar/checklist-linear'
import ISolarChecklistMinimalisticLinear from '~icons/solar/checklist-minimalistic-linear'
import ISolarChefHatLinear from '~icons/solar/chef-hat-linear'
import ISolarChefHatMinimalisticLinear from '~icons/solar/chef-hat-minimalistic-linear'
import ISolarChevronsUpDownLinear from '~icons/solar/chevrons-up-down-linear'
import ISolarCircleDotLinear from '~icons/solar/circle-dot-linear'
import ISolarClipboardListLinear from '~icons/solar/clipboard-list-linear'
import ISolarClipboardTextLinear from '~icons/solar/clipboard-text-linear'
import ISolarClockCircleLinear from '~icons/solar/clock-circle-linear'
import ISolarCloseCircleLinear from '~icons/solar/close-circle-linear'
import ISolarCloseLinear from '~icons/solar/close-linear'
import ISolarCloudStorageLinear from '~icons/solar/cloud-storage-linear'
import ISolarCloudUploadLinear from '~icons/solar/cloud-upload-linear'
import ISolarCodeLinear from '~icons/solar/code-linear'
import ISolarCompassLinear from '~icons/solar/compass-linear'
import ISolarCopyAddLinear from '~icons/solar/copy-add-linear'
import ISolarCopyLinear from '~icons/solar/copy-linear'
import ISolarCpuLinear from '~icons/solar/cpu-linear'
import ISolarCrownLinear from '~icons/solar/crown-linear'
import ISolarCrownMinimalisticLinear from '~icons/solar/crown-minimalistic-linear'
import ISolarCursorLinear from '~icons/solar/cursor-linear'
import ISolarDangerCircleLinear from '~icons/solar/danger-circle-linear'
import ISolarDangerLinear from '~icons/solar/danger-linear'
import ISolarDangerTriangleLinear from '~icons/solar/danger-triangle-linear'
import ISolarDatabaseLinear from '~icons/solar/database-linear'
import ISolarDisketteLinear from '~icons/solar/diskette-linear'
import ISolarDislikeLinear from '~icons/solar/dislike-linear'
import ISolarDocumentLinear from '~icons/solar/document-linear'
import ISolarDocumentTextLinear from '~icons/solar/document-text-linear'
import ISolarDollarMinimalisticLinear from '~icons/solar/dollar-minimalistic-linear'
import ISolarDoubleAltArrowLeftLinear from '~icons/solar/double-alt-arrow-left-linear'
import ISolarDoubleAltArrowRightLinear from '~icons/solar/double-alt-arrow-right-linear'
import ISolarDownloadLinear from '~icons/solar/download-linear'
import ISolarDumbbellLinear from '~icons/solar/dumbbell-linear'
import ISolarEyeClosedLinear from '~icons/solar/eye-closed-linear'
import ISolarEyeLinear from '~icons/solar/eye-linear'
import ISolarFaceScanCircleLinear from '~icons/solar/face-scan-circle-linear'
import ISolarFileAddLinear from '~icons/solar/file-add-linear'
import ISolarFileBracesLinear from '~icons/solar/file-braces-linear'
import ISolarFileChart2Linear from '~icons/solar/file-chart-2-linear'
import ISolarFileChartLinear from '~icons/solar/file-chart-linear'
import ISolarFileCodeLinear from '~icons/solar/file-code-linear'
import ISolarFileRemoveLinear from '~icons/solar/file-remove-linear'
import ISolarFileSendLinear from '~icons/solar/file-send-linear'
import ISolarFileTerminalLinear from '~icons/solar/file-terminal-linear'
import ISolarFilterLinear from '~icons/solar/filter-linear'
import ISolarFolderLinear from '~icons/solar/folder-linear'
import ISolarFolderOpenLinear from '~icons/solar/folder-open-linear'
import ISolarForbiddenCircleLinear from '~icons/solar/forbidden-circle-linear'
import ISolarFrameLinear from '~icons/solar/frame-linear'
import ISolarGalleryAddLinear from '~icons/solar/gallery-add-linear'
import ISolarGalleryLinear from '~icons/solar/gallery-linear'
import ISolarGalleryRemoveLinear from '~icons/solar/gallery-remove-linear'
import ISolarGalleryWideLinear from '~icons/solar/gallery-wide-linear'
import ISolarGiftLinear from '~icons/solar/gift-linear'
import ISolarGlobalLinear from '~icons/solar/global-linear'
import ISolarGraphUpLinear from '~icons/solar/graph-up-linear'
import ISolarGrid2x2Linear from '~icons/solar/grid-2x2-linear'
import ISolarGripVerticalLinear from '~icons/solar/grip-vertical-linear'
import ISolarHamburgerMenuLinear from '~icons/solar/hamburger-menu-linear'
import ISolarHashtagLinear from '~icons/solar/hashtag-linear'
import ISolarHeartLinear from '~icons/solar/heart-linear'
import ISolarHome2Linear from '~icons/solar/home-2-linear'
import ISolarInfoCircleLinear from '~icons/solar/info-circle-linear'
import ISolarKeyLinear from '~icons/solar/key-linear'
import ISolarKeyboardLinear from '~icons/solar/keyboard-linear'
import ISolarLampLinear from '~icons/solar/lamp-linear'
import ISolarLaptopLinear from '~icons/solar/laptop-linear'
import ISolarLayersLinear from '~icons/solar/layers-linear'
import ISolarLeafLinear from '~icons/solar/leaf-linear'
import ISolarLetterLinear from '~icons/solar/letter-linear'
import ISolarLibraryLinear from '~icons/solar/library-linear'
import ISolarLightbulbLinear from '~icons/solar/lightbulb-linear'
import ISolarLikeLinear from '~icons/solar/like-linear'
import ISolarLinkBrokenLinear from '~icons/solar/link-broken-linear'
import ISolarLinkLinear from '~icons/solar/link-linear'
import ISolarLinkMinimalisticLinear from '~icons/solar/link-minimalistic-linear'
import ISolarListArrowDownLinear from '~icons/solar/list-arrow-down-linear'
import ISolarListLinear from '~icons/solar/list-linear'
import ISolarLoaderLinear from '~icons/solar/loader-linear'
import ISolarLockKeyholeLinear from '~icons/solar/lock-keyhole-linear'
import ISolarLogout2Linear from '~icons/solar/logout-2-linear'
import ISolarMagicStick3Linear from '~icons/solar/magic-stick-3-linear'
import ISolarMagniferLinear from '~icons/solar/magnifer-linear'
import ISolarMagniferZoomInLinear from '~icons/solar/magnifer-zoom-in-linear'
import ISolarMagniferZoomOutLinear from '~icons/solar/magnifer-zoom-out-linear'
import ISolarMapLinear from '~icons/solar/map-linear'
import ISolarMapPointLinear from '~icons/solar/map-point-linear'
import ISolarMaximizeLinear from '~icons/solar/maximize-linear'
import ISolarMaximizeSquareLinear from '~icons/solar/maximize-square-linear'
import ISolarMentionCircleLinear from '~icons/solar/mention-circle-linear'
import ISolarMenuDotsLinear from '~icons/solar/menu-dots-linear'
import ISolarMenuDotsVerticalLinear from '~icons/solar/menu-dots-vertical-linear'
import ISolarMicrophoneLinear from '~icons/solar/microphone-linear'
import ISolarMinimizeLinear from '~icons/solar/minimize-linear'
import ISolarMinusCircleLinear from '~icons/solar/minus-circle-linear'
import ISolarMinusLinear from '~icons/solar/minus-linear'
import ISolarMoonLinear from '~icons/solar/moon-linear'
import ISolarMove3dLinear from '~icons/solar/move-3d-linear'
import ISolarMusicNoteLinear from '~icons/solar/music-note-linear'
import ISolarNotebookLinear from '~icons/solar/notebook-linear'
import ISolarNotebookMinimalisticLinear from '~icons/solar/notebook-minimalistic-linear'
import ISolarPaletteLinear from '~icons/solar/palette-linear'
import ISolarPanelLeftCloseLinear from '~icons/solar/panel-left-close-linear'
import ISolarPanelLeftLinear from '~icons/solar/panel-left-linear'
import ISolarPanelLeftOpenLinear from '~icons/solar/panel-left-open-linear'
import ISolarPanelRightLinear from '~icons/solar/panel-right-linear'
import ISolarPanelRightOpenLinear from '~icons/solar/panel-right-open-linear'
import ISolarPanelTopLinear from '~icons/solar/panel-top-linear'
import ISolarPaperclipLinear from '~icons/solar/paperclip-linear'
import ISolarPauseCircleLinear from '~icons/solar/pause-circle-linear'
import ISolarPauseLinear from '~icons/solar/pause-linear'
import ISolarPawLinear from '~icons/solar/paw-linear'
import ISolarPen2Linear from '~icons/solar/pen-2-linear'
import ISolarPenLinear from '~icons/solar/pen-linear'
import ISolarPenNewRoundLinear from '~icons/solar/pen-new-round-linear'
import ISolarPenNewSquareLinear from '~icons/solar/pen-new-square-linear'
import ISolarPhoneCallingLinear from '~icons/solar/phone-calling-linear'
import ISolarPinLinear from '~icons/solar/pin-linear'
import ISolarPinListLinear from '~icons/solar/pin-list-linear'
import ISolarPlain2Linear from '~icons/solar/plain-2-linear'
import ISolarPlaneLinear from '~icons/solar/plane-linear'
import ISolarPlayCircleLinear from '~icons/solar/play-circle-linear'
import ISolarPlayBold from '~icons/solar/play-bold'
import ISolarPlayLinear from '~icons/solar/play-linear'
import ISolarPlugCircleLinear from '~icons/solar/plug-circle-linear'
import ISolarPresentationGraphLinear from '~icons/solar/presentation-graph-linear'
import ISolarPrinterLinear from '~icons/solar/printer-linear'
import ISolarPulseLinear from '~icons/solar/pulse-linear'
import ISolarQuestionCircleLinear from '~icons/solar/question-circle-linear'
import ISolarQuestionSquareLinear from '~icons/solar/question-square-linear'
import ISolarQuoteLinear from '~icons/solar/quote-linear'
import ISolarRecordLinear from '~icons/solar/record-linear'
import ISolarRefreshLinear from '~icons/solar/refresh-linear'
import ISolarReorderLinear from '~icons/solar/reorder-linear'
import ISolarRestartLinear from '~icons/solar/restart-linear'
import ISolarRevoteLinear from '~icons/solar/revote-linear'
import ISolarRocketLinear from '~icons/solar/rocket-linear'
import ISolarRouteLinear from '~icons/solar/route-linear'
import ISolarRouting2Linear from '~icons/solar/routing-2-linear'
import ISolarSadCircleLinear from '~icons/solar/sad-circle-linear'
import ISolarSaleLinear from '~icons/solar/sale-linear'
import ISolarScaleLinear from '~icons/solar/scale-linear'
import ISolarServerSquareLinear from '~icons/solar/server-square-linear'
import ISolarSettingsLinear from '~icons/solar/settings-linear'
import ISolarShareLinear from '~icons/solar/share-linear'
import ISolarShieldCheckLinear from '~icons/solar/shield-check-linear'
import ISolarShieldCrossLinear from '~icons/solar/shield-cross-linear'
import ISolarShieldLinear from '~icons/solar/shield-linear'
import ISolarShieldWarningLinear from '~icons/solar/shield-warning-linear'
import ISolarShopLinear from '~icons/solar/shop-linear'
import ISolarShuffleLinear from '~icons/solar/shuffle-linear'
import ISolarSkipNextLinear from '~icons/solar/skip-next-linear'
import ISolarSledgehammerLinear from '~icons/solar/sledgehammer-linear'
import ISolarSlashSquareLinear from '~icons/solar/slash-square-linear'
import ISolarSortVerticalLinear from '~icons/solar/sort-vertical-linear'
import ISolarSpeakerMinimalisticLinear from '~icons/solar/speaker-minimalistic-linear'
import ISolarSpeedometerMiddleLinear from '~icons/solar/speedometer-middle-linear'
import ISolarSquareAcademicCapLinear from '~icons/solar/square-academic-cap-linear'
import ISolarSquareArrowRightUpLinear from '~icons/solar/square-arrow-right-up-linear'
import ISolarStarBold from '~icons/solar/star-bold'
import ISolarStarLinear from '~icons/solar/star-linear'
import ISolarStarsLinear from '~icons/solar/stars-linear'
import ISolarStarsMinimalisticLinear from '~icons/solar/stars-minimalistic-linear'
import ISolarStationLinear from '~icons/solar/station-linear'
import ISolarStethoscopeLinear from '~icons/solar/stethoscope-linear'
import ISolarStopCircleLinear from '~icons/solar/stop-circle-linear'
import ISolarStopLinear from '~icons/solar/stop-linear'
import ISolarSunLinear from '~icons/solar/sun-linear'
import ISolarTShirtLinear from '~icons/solar/t-shirt-linear'
import ISolarTablePropertiesLinear from '~icons/solar/table-properties-linear'
import ISolarTagLinear from '~icons/solar/tag-linear'
import ISolarTargetLinear from '~icons/solar/target-linear'
import ISolarTestTubeLinear from '~icons/solar/test-tube-linear'
import ISolarTextFieldLinear from '~icons/solar/text-field-linear'
import ISolarTextLinear from '~icons/solar/text-linear'
import ISolarTicketLinear from '~icons/solar/ticket-linear'
import ISolarTransferHorizontalLinear from '~icons/solar/transfer-horizontal-linear'
import ISolarTrashBinTrashLinear from '~icons/solar/trash-bin-trash-linear'
import ISolarTuning2Linear from '~icons/solar/tuning-2-linear'
import ISolarTuningLinear from '~icons/solar/tuning-linear'
import ISolarTuningSquareLinear from '~icons/solar/tuning-square-linear'
import ISolarUndoLeftLinear from '~icons/solar/undo-left-linear'
import ISolarUndoRightLinear from '~icons/solar/undo-right-linear'
import ISolarUploadLinear from '~icons/solar/upload-linear'
import ISolarUserCircleLinear from '~icons/solar/user-circle-linear'
import ISolarUserCrossLinear from '~icons/solar/user-cross-linear'
import ISolarUserHeartLinear from '~icons/solar/user-heart-linear'
import ISolarUserLinear from '~icons/solar/user-linear'
import ISolarUserMinusLinear from '~icons/solar/user-minus-linear'
import ISolarUserPlusLinear from '~icons/solar/user-plus-linear'
import ISolarUsersGroupRoundedLinear from '~icons/solar/users-group-rounded-linear'
import ISolarVerifiedCheckLinear from '~icons/solar/verified-check-linear'
import ISolarVideoFrameLinear from '~icons/solar/video-frame-linear'
import ISolarVideocameraLinear from '~icons/solar/videocamera-linear'
import ISolarWalkingLinear from '~icons/solar/walking-linear'
import ISolarWidget4Linear from '~icons/solar/widget-4-linear'
import ISolarWidget5Linear from '~icons/solar/widget-5-linear'
import ISolarWidgetAddLinear from '~icons/solar/widget-add-linear'

export interface IconProps extends SVGProps<SVGSVGElement> {
  /** Lucide sizing shorthand: sets width and height. */
  size?: number | string
  /** Accepted for Lucide compatibility and ignored: Solar Linear is drawn at 1.5px. */
  absoluteStrokeWidth?: boolean
}

export type IconComponent = ForwardRefExoticComponent<IconProps & RefAttributes<SVGSVGElement>>

/**
 * Lucide's defaults (24px, decorative, ref forwarded to the <svg> for Radix `asChild`)
 * on a compiled Solar component, plus a stable `icon-<name>` class (Lucide's was
 * `lucide-<name>`) that tests and styles can select.
 */
function solarIcon(Icon: ComponentType<SVGProps<SVGSVGElement>>, name: string): IconComponent {
  const nameClass = `icon icon-${name.replace(/([a-z0-9])([A-Z])/g, '$1-$2').replace(/([a-zA-Z])([0-9])/g, '$1-$2').toLowerCase()}`
  const SolarIcon = forwardRef(function SolarIcon(props: IconProps, ref: Ref<SVGSVGElement>) {
    const { size, width, height, strokeWidth, absoluteStrokeWidth, className, ...rest } = props
    void strokeWidth
    void absoluteStrokeWidth
    const isLabelled = Boolean(rest['aria-label'] || rest['aria-labelledby'])
    return createElement(Icon, {
      ref,
      width: width ?? size ?? 24,
      height: height ?? size ?? 24,
      'aria-hidden': isLabelled ? undefined : true,
      ...rest,
      className: className ? `${nameClass} ${className}` : nameClass,
    })
  })
  SolarIcon.displayName = name
  return SolarIcon
}

export const Activity = solarIcon(ISolarPulseLinear, 'Activity')
export const AlertCircle = solarIcon(ISolarDangerCircleLinear, 'AlertCircle')
export const AlertOctagon = solarIcon(ISolarDangerLinear, 'AlertOctagon')
export const AlertTriangle = solarIcon(ISolarDangerTriangleLinear, 'AlertTriangle')
export const AlignEndHorizontal = solarIcon(ISolarAlignBottomLinear, 'AlignEndHorizontal')
export const AlignStartVertical = solarIcon(ISolarAlignLeftLinear, 'AlignStartVertical')
export const AlignVerticalJustifyStart = solarIcon(ISolarAlignTopLinear, 'AlignVerticalJustifyStart')
export const Archive = solarIcon(ISolarArchiveLinear, 'Archive')
export const ArchiveRestore = solarIcon(ISolarArchiveUpLinear, 'ArchiveRestore')
export const ArrowDown = solarIcon(ISolarArrowDownLinear, 'ArrowDown')
export const ArrowDownRight = solarIcon(ISolarArrowRightDownLinear, 'ArrowDownRight')
export const ArrowDownToLine = solarIcon(ISolarArrowDownToLineLinear, 'ArrowDownToLine')
export const ArrowLeft = solarIcon(ISolarArrowLeftLinear, 'ArrowLeft')
export const ArrowLeftRight = solarIcon(ISolarTransferHorizontalLinear, 'ArrowLeftRight')
export const ArrowRight = solarIcon(ISolarArrowRightLinear, 'ArrowRight')
export const ArrowUp = solarIcon(ISolarArrowUpLinear, 'ArrowUp')
export const ArrowUpDown = solarIcon(ISolarSortVerticalLinear, 'ArrowUpDown')
export const ArrowUpRight = solarIcon(ISolarArrowRightUpLinear, 'ArrowUpRight')
export const AtSign = solarIcon(ISolarMentionCircleLinear, 'AtSign')
export const Baby = solarIcon(ISolarUserHeartLinear, 'Baby')
export const BadgeCheck = solarIcon(ISolarVerifiedCheckLinear, 'BadgeCheck')
export const Ban = solarIcon(ISolarForbiddenCircleLinear, 'Ban')
export const BarChart3 = solarIcon(ISolarChart2Linear, 'BarChart3')
export const Bell = solarIcon(ISolarBellLinear, 'Bell')
export const BellRing = solarIcon(ISolarBellBingLinear, 'BellRing')
export const BookMarked = solarIcon(ISolarBookmarkSquareLinear, 'BookMarked')
export const BookOpen = solarIcon(ISolarNotebookMinimalisticLinear, 'BookOpen')
export const BookOpenText = solarIcon(ISolarNotebookLinear, 'BookOpenText')
export const Bookmark = solarIcon(ISolarBookmarkLinear, 'Bookmark')
export const BookmarkPlus = solarIcon(ISolarBookmarkSquareMinimalisticLinear, 'BookmarkPlus')
export const Bot = solarIcon(ISolarBotLinear, 'Bot')
export const Boxes = solarIcon(ISolarBoxMinimalisticLinear, 'Boxes')
export const Braces = solarIcon(ISolarBracesLinear, 'Braces')
export const Briefcase = solarIcon(ISolarCaseLinear, 'Briefcase')
export const Bug = solarIcon(ISolarBugLinear, 'Bug')
export const Building = solarIcon(ISolarBuildingsLinear, 'Building')
export const Building2 = solarIcon(ISolarBuildings2Linear, 'Building2')
export const Cable = solarIcon(ISolarPlugCircleLinear, 'Cable')
export const Calculator = solarIcon(ISolarCalculatorLinear, 'Calculator')
export const Calendar = solarIcon(ISolarCalendarLinear, 'Calendar')
export const CalendarClock = solarIcon(ISolarCalendarDateLinear, 'CalendarClock')
export const CalendarRange = solarIcon(ISolarCalendarMinimalisticLinear, 'CalendarRange')
export const Car = solarIcon(ISolarCarLinear, 'Car')
export const Check = solarIcon(ISolarCheckLinear, 'Check')
export const CheckCheck = solarIcon(ISolarChecklistLinear, 'CheckCheck')
export const CheckCircle = solarIcon(ISolarCheckCircleLinear, 'CheckCircle')
export const CheckCircle2 = solarIcon(ISolarCheckCircleLinear, 'CheckCircle2')
export const CheckSquare = solarIcon(ISolarCheckSquareLinear, 'CheckSquare')
export const ChefHat = solarIcon(ISolarChefHatLinear, 'ChefHat')
export const ChevronDown = solarIcon(ISolarAltArrowDownLinear, 'ChevronDown')
export const ChevronFirst = solarIcon(ISolarDoubleAltArrowLeftLinear, 'ChevronFirst')
export const ChevronLast = solarIcon(ISolarDoubleAltArrowRightLinear, 'ChevronLast')
export const ChevronLeft = solarIcon(ISolarAltArrowLeftLinear, 'ChevronLeft')
export const ChevronRight = solarIcon(ISolarAltArrowRightLinear, 'ChevronRight')
export const ChevronUp = solarIcon(ISolarAltArrowUpLinear, 'ChevronUp')
export const ChevronsUpDown = solarIcon(ISolarChevronsUpDownLinear, 'ChevronsUpDown')
export const Circle = solarIcon(ISolarRecordLinear, 'Circle')
export const CircleDot = solarIcon(ISolarCircleDotLinear, 'CircleDot')
export const ClipboardCopy = solarIcon(ISolarCopyAddLinear, 'ClipboardCopy')
export const ClipboardList = solarIcon(ISolarClipboardListLinear, 'ClipboardList')
export const ClipboardPaste = solarIcon(ISolarClipboardTextLinear, 'ClipboardPaste')
export const Clock = solarIcon(ISolarClockCircleLinear, 'Clock')
export const Clock3 = solarIcon(ISolarClockCircleLinear, 'Clock3')
export const CloudCog = solarIcon(ISolarCloudStorageLinear, 'CloudCog')
export const Code2 = solarIcon(ISolarCodeLinear, 'Code2')
export const Coins = solarIcon(ISolarDollarMinimalisticLinear, 'Coins')
export const Compass = solarIcon(ISolarCompassLinear, 'Compass')
export const Copy = solarIcon(ISolarCopyLinear, 'Copy')
export const Cpu = solarIcon(ISolarCpuLinear, 'Cpu')
export const CreditCard = solarIcon(ISolarCardLinear, 'CreditCard')
export const Crosshair = solarIcon(ISolarTargetLinear, 'Crosshair')
export const Crown = solarIcon(ISolarCrownLinear, 'Crown')
export const Database = solarIcon(ISolarDatabaseLinear, 'Database')
export const DatabaseZap = solarIcon(ISolarServerSquareLinear, 'DatabaseZap')
export const Dice5 = solarIcon(ISolarShuffleLinear, 'Dice5')
export const Dog = solarIcon(ISolarPawLinear, 'Dog')
export const Download = solarIcon(ISolarDownloadLinear, 'Download')
export const Dumbbell = solarIcon(ISolarDumbbellLinear, 'Dumbbell')
export const Edit2 = solarIcon(ISolarPenLinear, 'Edit2')
export const Edit3 = solarIcon(ISolarPen2Linear, 'Edit3')
export const Equal = solarIcon(ISolarReorderLinear, 'Equal')
export const Expand = solarIcon(ISolarMaximizeSquareLinear, 'Expand')
export const ExternalLink = solarIcon(ISolarSquareArrowRightUpLinear, 'ExternalLink')
export const Eye = solarIcon(ISolarEyeLinear, 'Eye')
export const EyeOff = solarIcon(ISolarEyeClosedLinear, 'EyeOff')
export const FileBarChart = solarIcon(ISolarFileChartLinear, 'FileBarChart')
export const FileCode2 = solarIcon(ISolarFileCodeLinear, 'FileCode2')
export const FileJson = solarIcon(ISolarFileBracesLinear, 'FileJson')
export const FileJson2 = solarIcon(ISolarFileBracesLinear, 'FileJson2')
export const FileOutput = solarIcon(ISolarFileSendLinear, 'FileOutput')
export const FilePlus2 = solarIcon(ISolarFileAddLinear, 'FilePlus2')
export const FileQuestion = solarIcon(ISolarQuestionSquareLinear, 'FileQuestion')
export const FileSpreadsheet = solarIcon(ISolarFileChart2Linear, 'FileSpreadsheet')
export const FileText = solarIcon(ISolarDocumentTextLinear, 'FileText')
export const FileType = solarIcon(ISolarTextFieldLinear, 'FileType')
export const FileX2 = solarIcon(ISolarFileRemoveLinear, 'FileX2')
export const Film = solarIcon(ISolarVideoFrameLinear, 'Film')
export const Filter = solarIcon(ISolarFilterLinear, 'Filter')
export const FlaskConical = solarIcon(ISolarTestTubeLinear, 'FlaskConical')
export const Folder = solarIcon(ISolarFolderLinear, 'Folder')
export const FolderOpen = solarIcon(ISolarFolderOpenLinear, 'FolderOpen')
export const FolderPlus = solarIcon(ISolarAddFolderLinear, 'FolderPlus')
export const Frame = solarIcon(ISolarFrameLinear, 'Frame')
export const Frown = solarIcon(ISolarSadCircleLinear, 'Frown')
export const GalleryHorizontalEnd = solarIcon(ISolarGalleryWideLinear, 'GalleryHorizontalEnd')
export const GanttChart = solarIcon(ISolarChartLinear, 'GanttChart')
export const Gauge = solarIcon(ISolarSpeedometerMiddleLinear, 'Gauge')
export const Gem = solarIcon(ISolarCrownMinimalisticLinear, 'Gem')
export const Gift = solarIcon(ISolarGiftLinear, 'Gift')
export const GitBranch = solarIcon(ISolarBranchingPathsDownLinear, 'GitBranch')
export const GitCommit = solarIcon(ISolarCircleDotLinear, 'GitCommit')
export const Globe = solarIcon(ISolarGlobalLinear, 'Globe')
export const GraduationCap = solarIcon(ISolarSquareAcademicCapLinear, 'GraduationCap')
export const Grid3x3 = solarIcon(ISolarGrid2x2Linear, 'Grid3x3')
export const GripVertical = solarIcon(ISolarGripVerticalLinear, 'GripVertical')
export const Hammer = solarIcon(ISolarSledgehammerLinear, 'Hammer')
export const Hash = solarIcon(ISolarHashtagLinear, 'Hash')
export const Heart = solarIcon(ISolarHeartLinear, 'Heart')
export const HelpCircle = solarIcon(ISolarQuestionCircleLinear, 'HelpCircle')
export const Home = solarIcon(ISolarHome2Linear, 'Home')
export const Image = solarIcon(ISolarGalleryLinear, 'Image')
export const ImageIcon = solarIcon(ISolarGalleryLinear, 'ImageIcon')
export const ImageOff = solarIcon(ISolarGalleryRemoveLinear, 'ImageOff')
export const ImagePlus = solarIcon(ISolarGalleryAddLinear, 'ImagePlus')
export const Info = solarIcon(ISolarInfoCircleLinear, 'Info')
export const KeyRound = solarIcon(ISolarKeyLinear, 'KeyRound')
export const Keyboard = solarIcon(ISolarKeyboardLinear, 'Keyboard')
export const LampDesk = solarIcon(ISolarLampLinear, 'LampDesk')
export const Laptop = solarIcon(ISolarLaptopLinear, 'Laptop')
export const Layers = solarIcon(ISolarLayersLinear, 'Layers')
export const LayoutDashboard = solarIcon(ISolarWidget5Linear, 'LayoutDashboard')
export const LayoutGrid = solarIcon(ISolarWidget4Linear, 'LayoutGrid')
export const LayoutList = solarIcon(ISolarListLinear, 'LayoutList')
export const Library = solarIcon(ISolarLibraryLinear, 'Library')
export const Lightbulb = solarIcon(ISolarLightbulbLinear, 'Lightbulb')
export const Link = solarIcon(ISolarLinkLinear, 'Link')
export const Link2 = solarIcon(ISolarLinkMinimalisticLinear, 'Link2')
export const Link2Off = solarIcon(ISolarLinkBrokenLinear, 'Link2Off')
export const List = solarIcon(ISolarListLinear, 'List')
export const ListChecks = solarIcon(ISolarChecklistMinimalisticLinear, 'ListChecks')
export const ListOrdered = solarIcon(ISolarListArrowDownLinear, 'ListOrdered')
export const ListTodo = solarIcon(ISolarChecklistLinear, 'ListTodo')
export const Loader2 = solarIcon(ISolarLoaderLinear, 'Loader2')
export const Lock = solarIcon(ISolarLockKeyholeLinear, 'Lock')
export const LogOut = solarIcon(ISolarLogout2Linear, 'LogOut')
export const Mail = solarIcon(ISolarLetterLinear, 'Mail')
export const Map = solarIcon(ISolarMapLinear, 'Map')
export const MapIcon = solarIcon(ISolarMapLinear, 'MapIcon')
export const MapPin = solarIcon(ISolarMapPointLinear, 'MapPin')
export const Maximize2 = solarIcon(ISolarMaximizeLinear, 'Maximize2')
export const Megaphone = solarIcon(ISolarSpeakerMinimalisticLinear, 'Megaphone')
export const Menu = solarIcon(ISolarHamburgerMenuLinear, 'Menu')
export const MessageCircle = solarIcon(ISolarChatRoundLinear, 'MessageCircle')
export const MessageSquare = solarIcon(ISolarChatRoundLineLinear, 'MessageSquare')
export const MessageSquarePlus = solarIcon(ISolarChatSquareAddLinear, 'MessageSquarePlus')
export const MessagesSquare = solarIcon(ISolarDialog2Linear, 'MessagesSquare')
export const Mic = solarIcon(ISolarMicrophoneLinear, 'Mic')
export const Minimize2 = solarIcon(ISolarMinimizeLinear, 'Minimize2')
export const Minus = solarIcon(ISolarMinusLinear, 'Minus')
export const MinusCircle = solarIcon(ISolarMinusCircleLinear, 'MinusCircle')
export const Moon = solarIcon(ISolarMoonLinear, 'Moon')
export const MoreHorizontal = solarIcon(ISolarMenuDotsLinear, 'MoreHorizontal')
export const MoreVertical = solarIcon(ISolarMenuDotsVerticalLinear, 'MoreVertical')
export const MousePointerClick = solarIcon(ISolarCursorLinear, 'MousePointerClick')
export const Music = solarIcon(ISolarMusicNoteLinear, 'Music')
export const Package = solarIcon(ISolarBoxLinear, 'Package')
export const Palette = solarIcon(ISolarPaletteLinear, 'Palette')
export const PanelLeft = solarIcon(ISolarPanelLeftLinear, 'PanelLeft')
export const PanelLeftClose = solarIcon(ISolarPanelLeftCloseLinear, 'PanelLeftClose')
export const PanelLeftOpen = solarIcon(ISolarPanelLeftOpenLinear, 'PanelLeftOpen')
export const PanelRight = solarIcon(ISolarPanelRightLinear, 'PanelRight')
export const PanelRightOpen = solarIcon(ISolarPanelRightOpenLinear, 'PanelRightOpen')
export const PanelTop = solarIcon(ISolarPanelTopLinear, 'PanelTop')
export const Paperclip = solarIcon(ISolarPaperclipLinear, 'Paperclip')
export const Pause = solarIcon(ISolarPauseLinear, 'Pause')
export const PauseCircle = solarIcon(ISolarPauseCircleLinear, 'PauseCircle')
export const PenLine = solarIcon(ISolarPenNewRoundLinear, 'PenLine')
export const PenSquare = solarIcon(ISolarPenNewSquareLinear, 'PenSquare')
export const Pencil = solarIcon(ISolarPenLinear, 'Pencil')
export const PencilLine = solarIcon(ISolarPenNewRoundLinear, 'PencilLine')
export const Percent = solarIcon(ISolarSaleLinear, 'Percent')
export const PersonStanding = solarIcon(ISolarWalkingLinear, 'PersonStanding')
export const PhoneCall = solarIcon(ISolarPhoneCallingLinear, 'PhoneCall')
export const Pin = solarIcon(ISolarPinLinear, 'Pin')
export const PinOff = solarIcon(ISolarPinListLinear, 'PinOff')
export const Plane = solarIcon(ISolarPlaneLinear, 'Plane')
export const Play = solarIcon(ISolarPlayLinear, 'Play')
export const PlayCircle = solarIcon(ISolarPlayCircleLinear, 'PlayCircle')
export const Plug = solarIcon(ISolarPlugCircleLinear, 'Plug')
export const Plus = solarIcon(ISolarAddLinear, 'Plus')
export const Presentation = solarIcon(ISolarPresentationGraphLinear, 'Presentation')
export const Printer = solarIcon(ISolarPrinterLinear, 'Printer')
export const Quote = solarIcon(ISolarQuoteLinear, 'Quote')
export const Radio = solarIcon(ISolarStationLinear, 'Radio')
export const Redo2 = solarIcon(ISolarUndoRightLinear, 'Redo2')
export const RefreshCcw = solarIcon(ISolarRefreshLinear, 'RefreshCcw')
export const RefreshCw = solarIcon(ISolarRestartLinear, 'RefreshCw')
export const Rocket = solarIcon(ISolarRocketLinear, 'Rocket')
export const Rotate3d = solarIcon(ISolarMove3dLinear, 'Rotate3d')
export const RotateCcw = solarIcon(ISolarRestartLinear, 'RotateCcw')
export const RotateCw = solarIcon(ISolarRefreshLinear, 'RotateCw')
export const Route = solarIcon(ISolarRouteLinear, 'Route')
export const Save = solarIcon(ISolarDisketteLinear, 'Save')
export const Scale = solarIcon(ISolarScaleLinear, 'Scale')
export const ScanFace = solarIcon(ISolarFaceScanCircleLinear, 'ScanFace')
export const ScanSearch = solarIcon(ISolarMagniferZoomInLinear, 'ScanSearch')
export const ScrollText = solarIcon(ISolarDocumentLinear, 'ScrollText')
export const Search = solarIcon(ISolarMagniferLinear, 'Search')
export const Send = solarIcon(ISolarPlain2Linear, 'Send')
export const Settings = solarIcon(ISolarSettingsLinear, 'Settings')
export const Settings2 = solarIcon(ISolarTuning2Linear, 'Settings2')
export const Shapes = solarIcon(ISolarWidgetAddLinear, 'Shapes')
export const Share2 = solarIcon(ISolarShareLinear, 'Share2')
export const Shield = solarIcon(ISolarShieldLinear, 'Shield')
export const ShieldAlert = solarIcon(ISolarShieldWarningLinear, 'ShieldAlert')
export const ShieldCheck = solarIcon(ISolarShieldCheckLinear, 'ShieldCheck')
export const ShieldOff = solarIcon(ISolarShieldCrossLinear, 'ShieldOff')
export const ShieldX = solarIcon(ISolarShieldCrossLinear, 'ShieldX')
export const Shirt = solarIcon(ISolarTShirtLinear, 'Shirt')
export const ShoppingBag = solarIcon(ISolarBagLinear, 'ShoppingBag')
export const ShoppingCart = solarIcon(ISolarCartLinear, 'ShoppingCart')
export const Shuffle = solarIcon(ISolarShuffleLinear, 'Shuffle')
export const SkipForward = solarIcon(ISolarSkipNextLinear, 'SkipForward')
export const Slack = solarIcon(ISimpleIconsSlack, 'Slack')
export const SlidersHorizontal = solarIcon(ISolarTuningLinear, 'SlidersHorizontal')
export const Sparkle = solarIcon(ISolarStarsMinimalisticLinear, 'Sparkle')
export const Sparkles = solarIcon(ISolarStarsLinear, 'Sparkles')
export const Sprout = solarIcon(ISolarLeafLinear, 'Sprout')
export const Square = solarIcon(ISolarStopLinear, 'Square')
export const SquareSlash = solarIcon(ISolarSlashSquareLinear, 'SquareSlash')
export const Star = solarIcon(ISolarStarLinear, 'Star')
export const Stethoscope = solarIcon(ISolarStethoscopeLinear, 'Stethoscope')
export const StopCircle = solarIcon(ISolarStopCircleLinear, 'StopCircle')
export const Store = solarIcon(ISolarShopLinear, 'Store')
export const Sun = solarIcon(ISolarSunLinear, 'Sun')
export const Table = solarIcon(ISolarTablePropertiesLinear, 'Table')
export const Table2 = solarIcon(ISolarTablePropertiesLinear, 'Table2')
export const Tag = solarIcon(ISolarTagLinear, 'Tag')
export const Target = solarIcon(ISolarTargetLinear, 'Target')
export const Terminal = solarIcon(ISolarFileTerminalLinear, 'Terminal')
export const ThumbsDown = solarIcon(ISolarDislikeLinear, 'ThumbsDown')
export const ThumbsUp = solarIcon(ISolarLikeLinear, 'ThumbsUp')
export const Ticket = solarIcon(ISolarTicketLinear, 'Ticket')
export const ToggleLeft = solarIcon(IMingcuteToggleLeftLine, 'ToggleLeft')
export const ToggleRight = solarIcon(IMingcuteToggleRightLine, 'ToggleRight')
export const Trash2 = solarIcon(ISolarTrashBinTrashLinear, 'Trash2')
export const TrendingUp = solarIcon(ISolarGraphUpLinear, 'TrendingUp')
export const Type = solarIcon(ISolarTextLinear, 'Type')
export const Undo2 = solarIcon(ISolarUndoLeftLinear, 'Undo2')
export const Upload = solarIcon(ISolarUploadLinear, 'Upload')
export const UploadCloud = solarIcon(ISolarCloudUploadLinear, 'UploadCloud')
export const User = solarIcon(ISolarUserLinear, 'User')
export const UserCircle = solarIcon(ISolarUserCircleLinear, 'UserCircle')
export const UserMinus = solarIcon(ISolarUserMinusLinear, 'UserMinus')
export const UserPlus = solarIcon(ISolarUserPlusLinear, 'UserPlus')
export const UserX = solarIcon(ISolarUserCrossLinear, 'UserX')
export const Users = solarIcon(ISolarUsersGroupRoundedLinear, 'Users')
export const Utensils = solarIcon(ISolarChefHatMinimalisticLinear, 'Utensils')
export const Video = solarIcon(ISolarVideocameraLinear, 'Video')
export const Vote = solarIcon(ISolarRevoteLinear, 'Vote')
export const Wand2 = solarIcon(ISolarMagicStick3Linear, 'Wand2')
export const Workflow = solarIcon(ISolarRouting2Linear, 'Workflow')
export const Wrench = solarIcon(ISolarTuningSquareLinear, 'Wrench')
export const X = solarIcon(ISolarCloseLinear, 'X')
export const XCircle = solarIcon(ISolarCloseCircleLinear, 'XCircle')
export const Zap = solarIcon(ISolarBoltLinear, 'Zap')
export const ZoomIn = solarIcon(ISolarMagniferZoomInLinear, 'ZoomIn')
export const ZoomOut = solarIcon(ISolarMagniferZoomOutLinear, 'ZoomOut')

/* Solid variants for the places Lucide filled with `fill="currentColor"`: Solar's
   linear paths set their own fill, so a root `fill` prop does nothing on them. */
export const PlayFilled = solarIcon(ISolarPlayBold, 'PlayFilled')
export const StarFilled = solarIcon(ISolarStarBold, 'StarFilled')
// Effort dials: an open arc whose needle follows the level (custom, see icons/custom).
export const GaugeLow = solarIcon(IFairgenGaugeLow, 'GaugeLow')
export const GaugeMedium = solarIcon(IFairgenGaugeMedium, 'GaugeMedium')
export const GaugeHigh = solarIcon(IFairgenGaugeHigh, 'GaugeHigh')
